import { render } from "./PartnerUniversity.vue?vue&type=template&id=35aaca06&scoped=true"
import script from "./PartnerUniversity.vue?vue&type=script&lang=js"
export * from "./PartnerUniversity.vue?vue&type=script&lang=js"

import "./PartnerUniversity.vue?vue&type=style&index=0&id=35aaca06&scoped=true&lang=css"
import "./PartnerUniversity.vue?vue&type=style&index=1&id=35aaca06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aaca06"]])

export default __exports__